import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface NavItem {
  to: string;
  icon: string;
  label: string;
  adminOnly?: boolean;
}

const navItems: NavItem[] = [
  { to: '/dashboard',   icon: 'bi-grid-1x2-fill',    label: 'Dashboard' },
  { to: '/analysis',    icon: 'bi-bar-chart-line',   label: 'Insight' },
  { to: '/categories',  icon: 'bi-tags-fill',        label: 'Categories' },
  { to: '/rules',       icon: 'bi-funnel-fill',      label: 'Rules' },
  { to: '/digest',      icon: 'bi-envelope-fill',    label: 'Digest' },
  { to: '/users',       icon: 'bi-people-fill',      label: 'Users',   adminOnly: true },
  { to: '/profile',     icon: 'bi-person-fill',      label: 'Profile' },
];

export default function Sidebar() {
  const { user, signOut } = useAuth();

  const isAdmin = user.tier === 'system_admin' || user.tier === 'org_admin';
  const visibleItems = navItems.filter((item) => !item.adminOnly || isAdmin);

  const initials = user.displayName
    .split(' ')
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');

  return (
    <nav className="sidebar d-flex flex-column p-3" style={{ width: '220px', flexShrink: 0 }}>
      {/* Brand */}
      <div className="mb-4 px-2">
        <img src="/logo_sq.png" alt="Catty" style={{ width: 36, height: 36 }} />
      </div>

      {/* Nav links */}
      <ul className="nav flex-column flex-grow-1">
        {visibleItems.map((item) => (
          <li key={item.to} className="nav-item mb-1">
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                `nav-link d-flex align-items-center${isActive ? ' active' : ''}`
              }
            >
              <i className={`bi ${item.icon}`} aria-hidden="true" />
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>

      {/* User avatar + sign out */}
      <div className="border-top border-white border-opacity-25 pt-3 mt-3">
        <div className="d-flex align-items-center gap-2 mb-2 px-1">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
            style={{
              width: 34,
              height: 34,
              background: 'rgba(255,255,255,0.25)',
              fontSize: '0.8rem',
              fontWeight: 700,
            }}
          >
            {initials}
          </div>
          <div className="overflow-hidden">
            <div className="text-white fw-semibold text-truncate" style={{ fontSize: '0.85rem' }}>
              {user.displayName}
            </div>
            <div className="text-truncate" style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.65)' }}>
              {user.email}
            </div>
          </div>
        </div>
        <button
          className="btn btn-sm btn-outline-light w-100 d-flex align-items-center justify-content-center gap-1"
          onClick={() => void signOut()}
        >
          <i className="bi bi-box-arrow-right" aria-hidden="true" />
          Sign out
        </button>
      </div>
    </nav>
  );
}
